import React from "react"

import Search from "../../../gd-components/popover-menu/search/search"

type Props = {
    searchString    : string | null

    searchable      : boolean

    onSearchChange  : func
    onHidePopover   : func
}

export default function SelectMultiGenericPopoverSearch(props: Props) {
    if (props.searchable) {
        return <Search searchString={props.searchString} onSearch={props.onSearchChange} onEscapePressed={props.onHidePopover}/>
    } else {
        // still need to autofocus so keyboard work
        return <span className="hidden-search-input" tabIndex={0} />
    }
}